function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { boxShadow } from "../../ThemeProvider/cssFor";
var useStyle = function(param1) {
    var appearance = param1.appearance, dismissible = param1.dismissible, isRtl = param1.isRtl, isPositionFixed = param1.isPositionFixed;
    var correctedAppearance = appearance === 'info' ? 'interactive' : appearance;
    var builtStyle = useBuildStyleWithTheme(function(theme, param, flags) {
        var start = param.start, end = param.end, readingDirection = param.readingDirection;
        return buildStyle(theme, {
            appearance: correctedAppearance,
            start: start,
            end: end,
            readingDirection: readingDirection
        }, flags);
    }, {
        isRtl: isRtl
    });
    if (typeof builtStyle !== 'undefined') {
        var container = builtStyle.container, titleContent = builtStyle.titleContent, dismissButton = builtStyle.dismissButton, action = builtStyle.action, icon = builtStyle.icon, rest = _objectWithoutProperties(builtStyle, [
            "container",
            "titleContent",
            "dismissButton",
            "action",
            "icon"
        ]);
        return _objectSpread({
            container: _objectSpread({}, container.base, isPositionFixed && container.isPositionFixed.base),
            titleContent: titleContent,
            dismissButton: {
                buttonStyle: _objectSpread({}, dismissButton.base, dismissButton.buttonStyle),
                iconStyle: {}
            },
            action: _objectSpread({}, action.base, dismissible && action.dismissible, {
                a: action.a
            }),
            icon: _objectSpread({}, icon.base, appearance === 'warning' && icon.warning),
            content: {}
        }, rest);
    }
    return {
        container: {},
        dismissButton: {
            buttonStyle: {},
            iconStyle: {}
        },
        action: {},
        icon: {},
        content: {},
        titleContent: {},
        title: {},
        contentAction: {},
        dismiss: {}
    };
};
export { useStyle };
var buildStyle = function(theme, param, param2) {
    var appearance = param.appearance, start = param.start, end = param.end, readingDirection = param.readingDirection, typographyUpdates = param2.typographyUpdates;
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return {
        container: {
            base: _objectSpread((_obj = {
                pointerEvents: 'auto',
                display: 'flex',
                backgroundColor: theme.backgroundColor[appearance].surface,
                lineHeight: theme.font.lineHeight.heading,
                minHeight: 50,
                borderRadius: theme.size.border.radius.fiveX,
                boxSizing: 'border-box',
                boxShadow: boxShadow(theme.depth.boxShadow[4]),
                alignItems: 'flex-start',
                justifyContent: 'center'
            }, _defineProperty(_obj, end.padding, theme.spacing[4]), _defineProperty(_obj, "width", '100%'), _defineProperty(_obj, "maxWidth", 560), _obj), readingDirection),
            isPositionFixed: {
                base: {
                    position: 'fixed',
                    top: 20,
                    width: 'calc(100% - 40px)',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: theme.depth.zIndex[1600]
                }
            }
        },
        icon: {
            base: (_obj1 = {
                alignSelf: 'stretch',
                display: 'flex',
                alignItems: 'flex-start',
                paddingTop: theme.spacing[4],
                paddingBottom: theme.spacing[4]
            }, _defineProperty(_obj1, start.padding, theme.spacing[4]), _defineProperty(_obj1, end.padding, theme.spacing[5]), _defineProperty(_obj1, "svg", {
                fill: theme.font.color[appearance].hover
            }), _obj1),
            warning: {
                svg: {
                    fill: theme.font.color.warning.base
                }
            }
        },
        titleContent: (_obj2 = {
            fontFamily: theme.font.base.family,
            fontStyle: 'normal',
            fontSize: theme.font.base.size[3],
            letterSpacing: 'normal',
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            color: theme.font.color.base
        }, _defineProperty(_obj2, end.margin, theme.spacing[6]), _defineProperty(_obj2, "marginTop", theme.spacing[5]), _defineProperty(_obj2, "marginBottom", theme.spacing[5]), _obj2),
        title: {
            marginBottom: theme.spacing[3],
            fontWeight: typographyUpdates ? theme.font.base.weight.medium : theme.font.base.weight.bold
        },
        contentAction: _objectSpread({
            display: 'flex',
            alignItems: 'flex-start',
            width: '100%'
        }, readingDirection),
        action: {
            base: (_obj3 = {
                marginTop: theme.spacing[5],
                marginBottom: theme.spacing[5]
            }, _defineProperty(_obj3, start.margin, 'auto'), _defineProperty(_obj3, end.margin, theme.spacing[5]), _obj3),
            a: {
                color: theme.font.color[appearance].hover,
                fontWeight: typographyUpdates ? theme.font.base.weight.medium : theme.font.base.weight.bold,
                fontSize: theme.font.base.size[3]
            },
            dismissible: _defineProperty({}, end.margin, 0)
        },
        dismiss: (_obj4 = {}, _defineProperty(_obj4, start.margin, theme.spacing[3]), _defineProperty(_obj4, end.margin, 0), _defineProperty(_obj4, "marginTop", theme.spacing[3]), _defineProperty(_obj4, "marginBottom", theme.spacing[3]), _defineProperty(_obj4, "alignSelf", 'flex-start'), _defineProperty(_obj4, "height", 36), _defineProperty(_obj4, "cursor", 'pointer'), _obj4),
        dismissButton: {
            base: {
                borderRadius: theme.size.border.radius.round,
                border: 'none',
                width: 36,
                height: 36,
                margin: 0,
                padding: 0,
                backgroundColor: theme.backgroundColor[appearance].surface,
                transition: "background-color ".concat(theme.animation.expressive.easeOut.easing, " ").concat(theme.animation.duration[100], ", color ").concat(theme.animation.expressive.easeOut.easing, " ").concat(theme.animation.duration[100], ", border-color ").concat(theme.animation.expressive.easeOut.easing, " ").concat(theme.animation.duration[100], ", box-shadow ").concat(theme.animation.productive.easeInOut.easing, " ").concat(theme.animation.duration[100]),
                svg: {
                    fill: theme.font.color.neutral.hover
                },
                '&:hover': {
                    backgroundColor: appearance === 'warning' ? theme.backgroundColor.warning.active : theme.backgroundColor[appearance].hover
                },
                '&:active': {
                    backgroundColor: appearance === 'warning' ? theme.backgroundColor.warning.fill.focus : theme.backgroundColor[appearance].active
                },
                '&:focus-visible': {
                    outline: 0,
                    boxShadow: "0 0 0 ".concat(theme.size.border.focus, "px ").concat(theme.borderColor.interactive.focus)
                }
            },
            buttonStyle: {},
            iconStyle: {}
        }
    };
};
